import {
  Button,
  Card,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from "@material-ui/core";
import alertify from "alertifyjs";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import React, { useEffect, useState } from "react";
import APIModel from "../../Models/APIModel";
import SideNav from "../Layout/SideNav";
import styled from "styled-components";
import Loader from "react-loader-spinner";
import SearchBar from "material-ui-search-bar";
import DeleteIcon from "@material-ui/icons/Delete";
import { Box } from "@mui/system";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { displayAlertifyError } from "../../util/functions";

const defaultTax = {
  name: "",
  percentage: 0,
};
function Taxes() {
  // states
  let get_token = localStorage.getItem("Token");
  let user_status = localStorage.getItem("status");
  const [token, setToken] = useState(get_token);
  const [taxes, setTaxes] = useState([]);
  const [tax, setTax] = useState(defaultTax);
  const [showTaxes, setShowTaxes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [searching, setSearching] = useState(false);
  const [editing, setEditing] = useState(false);
  const [open, setOpen] = useState(false);
  const [delId, setDelId] = useState("");
  // effects
  useEffect(() => {
    getTaxes();
  }, []);
  useEffect(() => {
    !searching ? setShowTaxes(taxes) : filter();
  }, [search]);

  // functions
  const getTaxes = async () => {
    setLoading(true);
    await axios
      .get(APIModel.HOST + "get-taxes", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        console.log(res.data.taxes);
        setTaxes(res.data.taxes);
        setShowTaxes(res.data.taxes);
        setTimeout(() => {
          setLoading(false);
        }, 500);
      })
      .catch((err) => displayAlertifyError({ error: err }));
  };

  const handleTax = async (type) => {
    const param = tax;
    console.log(param);
    await axios
      .post(APIModel.HOST + `${type}-tax`, param, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        alertify.success(res.data.message);
      })
      .catch((err) => displayAlertifyError({ error: err }));

    getTaxes();
  };

  const deleteTax = async (id) => {
    closeDialog();
    if (editing) setEditing(false);
    const param = { id: id };
    console.log(param);
    setTax(defaultTax);
    await axios
      .post(APIModel.HOST + "delete-tax", param, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + token,
        },
      })
      .then((res) => {
        alertify.success(res.data.message);
      })
      .catch((err) => displayAlertifyError({ error: err }));

    getTaxes();
  };

  const scrollToTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const scrollToBottom = () => {
    window.scroll({
      top: document.body.scrollHeight,
      left: 0,
      behavior: "smooth",
    });
  };

  const handleFilterSearch = (value) => {
    setSearch(value);
    if (!searching && value !== "") setSearching(true);
    else if (searching && value === "") setSearching(false);
  };

  const handleSelected = (id) => {
    setEditing(true);
    setTax(taxes.filter((item) => item.id === id)[0]);
    //  scrollToBottom();
  };

  const cancelSelected = () => {
    setTax(defaultTax);
    setEditing(false);
    //  scrollToTop();
  };

  const filter = () =>
    setShowTaxes(
      taxes.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      )
    );

  const handleTaxChange = (e) =>
    setTax({ ...tax, [e.target.name]: e.target.value });

  const openDialog = (id) => {
    if (id !== "") {
      console.log(id);
      setDelId(id);
      setOpen(true);
    }
  };

  const closeDialog = () => {
    if (delId !== "") {
      setDelId("");
      setOpen(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    editing ? handleTax("update") : handleTax("create");
    if (editing) setEditing(false);
    setTax(defaultTax);
    // scrollToTop();
  };
  if (token) {
    if (user_status === "user") {
      return <Redirect to="/payment"></Redirect>;
    } else {
      return (
        <>
          <div className="wrapper">
            <SideNav />
            <div className="main-panel">
              <div className="content">
                <div className="container-fluid">
                  <Grid container>
                    <Grid item md={6} sm={6} xs={12}>
                      <DivShowTaxes>
                        <div className="card">
                          <SearchBar
                            placeholder="Search"
                            value={search}
                            onChange={handleFilterSearch}
                            onCancelSearch={() => handleFilterSearch("")}
                          />
                          <Dialog
                            open={open}
                            onClose={closeDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                          >
                            <DialogTitle id="alert-dialog-title">
                              {"Tax Delete Alert"}
                            </DialogTitle>
                            <DialogContent>
                              <DialogContentText id="alert-dialog-description">
                                Are you sure you want to delete the tax ?
                              </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                              <Button
                                color="secondary"
                                variant="outlined"
                                size="small"
                                onClick={closeDialog}
                              >
                                No
                              </Button>
                              <Button
                                color="primary"
                                variant="contained"
                                size="small"
                                onClick={() => deleteTax(delId)}
                                autoFocus
                              >
                                Yes
                              </Button>
                            </DialogActions>
                          </Dialog>
                          {!loading ? (
                            <div
                              className="card-body mt-2"
                              style={{
                                maxHeight: 400,
                                minHeight: 400,
                                overflowY: "auto",
                              }}
                            >
                              <div>
                                {showTaxes.length > 0 ? (
                                  showTaxes.map((item) => (
                                    <List
                                      component="nav"
                                      aria-label="secondary mailbox folders"
                                      key={item.id}
                                    >
                                      <ListItem
                                        button
                                        onClick={() => handleSelected(item.id)}
                                        key={item.id}
                                        id={item.id}
                                      >
                                        <ListItemText
                                          className="tax-name"
                                          primary={item.name}
                                        />
                                      </ListItem>
                                      <ListItemSecondaryAction>
                                        <IconButton
                                          onClick={() => openDialog(item.id)}
                                          className="del-icon"
                                        >
                                          <DeleteIcon color="error" />
                                        </IconButton>
                                      </ListItemSecondaryAction>
                                      <Divider />
                                    </List>
                                  ))
                                ) : (
                                  <h4>No Taxes found!</h4>
                                )}
                              </div>
                            </div>
                          ) : (
                            <DivLoader>
                              <Loader
                                type="Oval"
                                color="#FC3538"
                                height={50}
                                width={50}
                              />
                            </DivLoader>
                          )}
                        </div>
                      </DivShowTaxes>
                    </Grid>
                    <Grid item md={6} sm={6} xs={12}>
                      <DivTaxesForm>
                        <div className="card">
                          <div className="card-body">
                            <form onSubmit={handleSubmit}>
                              <div
                                className="row"
                                style={{
                                  maxHeight: 370,
                                  minHeight: 370,
                                  overflow: "auto",
                                }}
                              >
                                <Box
                                  fontSize={20}
                                  fontWeight="bold"
                                  ml={2}
                                  mb={1}
                                >
                                  {editing ? "Edit Tax" : "Add Tax"}
                                </Box>
                                <div className="col-12">
                                  <div className="form-group">
                                    <label className="mdc-floating-label--shake">
                                      Name
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control input-box"
                                      name="name"
                                      value={tax.name}
                                      onChange={handleTaxChange}
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="col-12">
                                  <div className="form-group">
                                    <label className="mdc-floating-label--shake">
                                      Tax
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control input-box"
                                      name="percentage"
                                      value={tax.percentage}
                                      onChange={handleTaxChange}
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              {editing && (
                                <button
                                  type="button"
                                  onClick={cancelSelected}
                                  className="btn btn-primary pull-right mr-2"
                                >
                                  <b>Cancel</b>
                                </button>
                              )}
                              <button
                                type="submit"
                                className="btn btn-primary pull-right mr-2"
                              >
                                {editing ? "Update Tax" : "Add Tax"}
                              </button>
                            </form>
                          </div>
                        </div>
                      </DivTaxesForm>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  } else {
    return <Redirect to="/"></Redirect>;
  }
}

export default Taxes;

const DivShowTaxes = styled.div`
  padding: 0px 15px;
  .tax-name {
    color: #fc3538;
  }
  .del-icon {
    position: relative;
    bottom: 3px;
    opacity: 0.85;
    cursor: pointer;
    &:hover {
      transition: 0.25s all ease-in-out;
      opacity: 1;
    }
  }
`;

const DivTaxesForm = styled.div`
  padding: 0px 15px;
`;

const DivLoader = styled.div`
  text-align: center;
  margin: 30px 0px;
`;
